import React from "react";

import Map from '../../assets/images/ForeignGeneer/ForeignGeneer_map.png'; // Image est en 1600x900
import Player from '../../assets/images/ForeignGeneer/ForeignGeneer_player.png';
import Spawn from '../../assets/images/ForeignGeneer/ForeignGeneer_spawn.png';

function Project_foreignGeneer() {

    const skills = ["Godot", "Blender", "Substance Painter"];

    return(
    <div className="projects-windows" id="projects">

        <h1>ForeignGeneer</h1>
        <p>Pour conclure notre deuxième année de BUT informatique, nous avions pour objectif, par groupe de six, de créer notre jeu vidéo : ForeignGeneer</p><br></br>
        <p> "<i>En tant qu'ingénieur pour Solar Corporation, vous voyagez dans l'espace et offrez vos services aux quatre coins de la galaxie.
            Pendant l'une de vos nombreuses journées où la répétition de ce métier se fait sentir, vous recevez un signal étrange
            d'une origine inconnue qui semble diriger votre vaisseau sans que vous n'y puissiez rien. Lorsque vous arrivez sur la planète
            d'où vient le signal, un champ magnétique étrange grille tous les systèmes de bord, vous faisant prisonnier de la planète.
            En explorant, vous ne voyez que des ruines ainsi qu'une faune et flore submergées par des détritus. Quels choix ferez-vous
            pour essayer de sauver cette planète et ses potentiels survivants ? Des robots, témoins du passé tragique de la planète, vous
            aideront si vous les réparez. Pourquoi sont-ils les seuls êtres intelligents qui ont survécu ? Qu'est-il arrivé ? Cela deviendra
            votre nouvelle mission : résoudre le mystère de cette planète.</i>"</p><br></br>

        <h1>Objectif et étapes de création</h1>
        <p>L'objectif de ce projet est de créer un jeu vidéo qui mêle écologie et exploration. Nous voulions ainsi, par l'intermédiaire
            de ForeignGeneer, pousser le joueur à voir l'impact de ses actions sur l'environnement. Le joueur a ainsi le choix d'avancer
            vite, mais en risquant de détruire la planète à tout jamais, ou bien de prendre des outils plus écologiques, mais qui font
            progresser la partie plus lentement.</p><br></br>

        <img className="img" src={Spawn} alt="Spawn du jeu" />
        <p>Point de spawn du jeu</p><br></br>

        <p>Ce projet a commencé vers novembre 2024. Nous avons décidé du gameplay et du scénario du jeu : un jeu basé sur l'exploration, qui mettra en
            valeur la gestion de son environnement. Nous voulions que chaque choix de machine ou de craft ait un impact, positif ou négatif, sur l'environnement.
            Le joueur doit donc rester économe tout en avançant vers son objectif : reconstruire son vaisseau.
            Le scénario étant créé, nous pouvons maintenant passer à la création de l'UML pour définir ce qui devra être fait côté programmation.
            Le développement du jeu peut commencer : création de la map, développement des crafts et de l'inventaire, ajout des menus et de l'interface utilisateur, etc.
            Nous avons également régulièrement réalisé des réunions pour observer l'avancement de chacun et définir les prochaines étapes du projet.
        </p>

        <img className="img" src={Map} alt="Vue en hauteur de la map du jeu" />
        <p>Vue d'ensemble de la carte</p><br></br>

        <h2>Outils utilisés :</h2>
        {skills.map((skill) => <p key={skill}>{skill}</p>)}<br></br>

        <h2>Langage utilisé :</h2><br></br>
        <p><strong>- C#</strong></p><br></br>

        <h2>Pour conclure</h2>
        <p>L'objectif principal de ce projet était de créer un jeu vidéo qui sensibilise aux enjeux environnementaux tout en permettant
            de passer un bon moment à explorer une nouvelle planète. C'est chose faite avec ForeignGeneer, qui mêle ces deux facettes
            dans son gameplay.</p>

        <h3>Écologie</h3>
        <p>Ce jeu ne se contente pas seulement de sensibiliser, mais applique aussi cette philosophie dans son développement.
            Tout d'abord, ForeignGeneer a été créé sur Godot, un moteur de jeu open source et peu gourmand en ressources, contrairement
            à ses concurrents comme Unreal ou Unity, qui nécessitent beaucoup plus de ressources pour la construction de leurs jeux.
            Ensuite, concernant les modèles et décors du jeu, tous sont en low-poly, ce qui permet de diminuer le nombre de polygones que
            l'ordinateur doit afficher à l'écran. Couplé à un système de LOD (Level Of Detail), une méthode de rendu des objets lointains,
            n'importe quel ordinateur peut faire tourner le jeu sans gaspiller ses ressources, tout en restant fluide.</p><br></br>
        <img className="img" src={Player} alt="Joueur avec les caractéristiques" />
        <p>Le personnage principal en low poly, depuis Blender</p><br></br>

        <h3>Exploration</h3>
        <p>L'exploration est un point essentiel de notre jeu, avec 5 zones distinctes, chacune ayant des décors et des spécificités
            uniques. Le joueur devra progresser à travers la carte pour récolter les ressources nécessaires à sa survie et découvrira
            parfois des éléments qui lui permettront d'en apprendre davantage sur cette planète. L'exploration de son environnement
            donnera ainsi un intérêt à sa présence et créera un environnement unique propre au jeu.</p><br></br>

        <h3>Expérience et compétences acquises</h3>

        <p>Cette première expérience dans la création d'un jeu complet, de A à Z, nous a permis de plonger dans l'univers du
            développement de jeux vidéo. Nous avons découvert et maîtrisé plusieurs outils, tels que Godot. Cette immersion nous
            a offert l'opportunité de développer nos compétences dans divers domaines clés de la création de jeux, notamment la
            modélisation 3D, la programmation en C# et les blueprints, le game design, etc.</p>

        <p>Un projet de cette envergure, qui a pris plus de 5 mois à être réalisé, nous a également appris à gérer efficacement
            un projet en équipe. Nous avons développé des compétences essentielles en gestion du temps, en communication au sein
            du groupe et en entraide entre les membres. Ces expériences nous ont rendus plus matures et nous ont permis de gagner
            en expérience dans le domaine de la création de jeux vidéo.</p>
    </div>
    );
}

export default Project_foreignGeneer;